export default __webpack_public_path__ + "static/media/Sea.fd0b830b.jpg";